import React, { useState } from 'react';
import { Button, FormControl, Modal, Grid, MenuItem, makeStyles } from '@material-ui/core';
import axios from 'axios';
import { connect } from 'redux-zero/react';
import actions from '../../actions';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import SharpTextField from '../SharpTextField';
import SharpSelectField from '../SharpSelectField';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 800,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 800
    },
    formControlFullWidth: {
        margin: theme.spacing(1),
        width: '100%',
    },
}));

const mapToProps = ({ selectedSociety }) => ({ selectedSociety });

function ResidentEdit({ selectedSociety, mode, model, onClose }) {
    const classes = useStyles();
    const [error, setError] = useState('');

    function onSubmit(formvalue) {
        setError('');

        let value = Object.assign({}, formvalue);

        if (value.title === '') {
            value.title = null;
        }

        if (value.middleName === '') {
            value.middleName = null;
        }

        if (value.email === '') {
            value.email = null;
        }

        if (value.phone === '') {
            value.phone = null;
        }

        if (value.mobile === '') {
            value.mobile = null;
        }

        if (mode === 'Create') {
            axios({
                method: 'POST',
                url: '/resident',
                headers: { 'X-SocietyId': selectedSociety },
                data: JSON.stringify(value)
            })
                .then(response => {
                    onClose();
                })
                .catch(error => {
                    setError('Error: ' + error.response.data.message);
                });
        } else if (mode === 'Edit') {
            axios({
                method: 'PUT',
                url: '/resident/' + model.id,
                headers: { 'X-SocietyId': selectedSociety },
                data: JSON.stringify(value)
            })
                .then(response => {
                    onClose();
                })
                .catch(error => {
                    setError('Error: ' + error.response.data.message);
                });
        }
    }

    return (
        <Modal className={classes.modal} open={(model != null)} onClose={onClose}>
            <div className={classes.paper}>
                <h2 id="transition-modal-title">{mode} Member/Resident</h2>
                <Formik initialValues={model}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        type: Yup.string().required('Required'),
                        title: Yup.string().nullable(),
                        firstName: Yup.string().required('Required'),
                        middleName: Yup.string().nullable(),
                        lastName: Yup.string().required('Required'),
                        email: Yup.string(),
                        phone: Yup.string(),
                        mobile: Yup.string()
                    })}
                    validateOnMount={true}
                    onSubmit={onSubmit}
                >
                    {({ isValid }) => (
                        <Form autoComplete="off" onKeyDown={(e) => { if (e.keyCode === 13 && e.target.id !== 'save') e.preventDefault(); }}>
                            <div>
                                <FormControl className={classes.formControlFullWidth}>
                                    <SharpSelectField
                                        id="type"
                                        name="type"
                                        label="Type"
                                        fullWidth
                                        onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('title').focus(); } }}
                                    >
                                        <MenuItem value={'Member'}>Member</MenuItem>
                                        <MenuItem value={'Associate Member'}>Associate Member</MenuItem>
                                        <MenuItem value={'Resident'}>Resident</MenuItem>
                                    </SharpSelectField>
                                </FormControl>
                            </div>
                            <div>
                                <Grid container>
                                    <Grid item xs={3}>
                                        <FormControl className={classes.formControlFullWidth}>
                                            <SharpTextField
                                                id="title"
                                                name="title"
                                                label="Title"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('firstName').focus(); } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl className={classes.formControlFullWidth}>
                                            <SharpTextField
                                                id="firstName"
                                                name="firstName"
                                                label="First Name"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('middleName').focus(); } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl className={classes.formControlFullWidth}>
                                            <SharpTextField
                                                id="middleName"
                                                name="middleName"
                                                label="Middle Name"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('lastName').focus(); } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl className={classes.formControlFullWidth}>
                                            <SharpTextField
                                                id="lastName"
                                                name="lastName"
                                                label="Last Name"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('email').focus(); } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <Grid container>
                                    <Grid item xs={3}>
                                        <FormControl className={classes.formControlFullWidth}>
                                            <SharpTextField
                                                id="email"
                                                name="email"
                                                label="Email"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('phone').focus(); } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl className={classes.formControlFullWidth}>
                                            <SharpTextField
                                                id="phone"
                                                name="phone"
                                                label="Phone"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('mobile').focus(); } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl className={classes.formControlFullWidth}>
                                            <SharpTextField
                                                id="mobile"
                                                name="mobile"
                                                label="Mobile"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('save').focus(); } }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                {error}
                            </div>
                            <div>
                                <Button id="save" variant="contained" color="primary" type="submit" disabled={!isValid}>
                                    Save
                            </Button>
                                <Button variant="contained" color="secondary" type="submit" onClick={() => { setError(''); onClose(); }}>
                                    Cancel
                            </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Modal >
    );
}

export default connect(mapToProps, actions)(ResidentEdit);